<template>
  <div class="app-body">
    <el-tabs v-model="currentTab" @change="tabChanged">
      <el-tab-pane label="物料发货记录" name="purchase">
        <SendTable source-type="purchase" query-type="seller"></SendTable>
      </el-tab-pane>
      <el-tab-pane label="加工发货记录" name="make">
        <SendTable source-type="make" query-type="seller"></SendTable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SendTable from '@/views/modules/erp/send/v2/send-table.vue'

export default {
  name: 'erp-send-v2-index',
  components: { SendTable },
  data () {
    return {
      currentTab: 'purchase',
      cacheKey:"erp:factory:client:send-list"
    }
  },
  activated(){
    let localCurrentTab=window.localStorage.getItem(this.cacheKey)
    if(localCurrentTab){
      this.currentTab=localCurrentTab
    }
  },
  watch:{
    currentTab(newVal){
      window.localStorage.setItem(this.cacheKey,newVal)
    }
  },
  methods:{
    tabChanged(e){
      console.log('tabChanged',e)
    }
  }
}
</script>

<style scoped>

</style>
